// permission.guard.ts

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { AuthService } from '@auth/services';
import { map, Observable, take } from 'rxjs';
import { PortalService } from 'src/app/portal/services/portal.service';

@Injectable({ providedIn: 'root' })
export class PermissionGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private portalService: PortalService,
    private router: Router,
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    // `permission` admite un string o una lista. Con lista alcanza con tener
    // uno: hay pantallas a las que se llega por dos caminos distintos —el
    // admin del municipio por su permiso propio, el superadmin por su alcance
    // global— y exigir un único slug dejaba afuera a uno de los dos.
    const requerido = route.data['permission'] as string | string[];
    const requeridos = Array.isArray(requerido) ? requerido : [requerido];

    return this.authService.currentUser$.pipe(
      take(1),
      map((user) => {
        if (!user) {
          const entidad = this.portalService.getCurrentEntityValue();
          const loginPath = entidad ? `/${entidad.slug}/login` : '/';
          this.router.navigate([loginPath]);
          return false;
        }

        if (requeridos.some((p) => this.authService.hasPermission(p))) {
          return true;
        } else {
          console.warn(`Acceso denegado a ${requeridos.join(' | ')}`);

          // Antes redirigía a '/home', que no existe como ruta: caía en el
          // comodín '**' y renderizaba NotFoundComponent, que vive FUERA del
          // LayoutComponent de /sistema. El usuario perdía el sidebar y el
          // header de golpe, así que una simple falta de permiso parecía un
          // cierre de sesión. El dashboard sí existe y mantiene el shell.
          this.router.navigate(['/sistema/dashboard']);

          return false;
        }
      }),
    );
  }
}
